module.exports = __webpack_public_path__ + "static/media/21ECLAC7.1c890622.jpg";